import { render, staticRenderFns } from "./ListingItemActiveSessions.vue?vue&type=template&id=2bd54a40"
import script from "./ListingItemActiveSessions.vue?vue&type=script&lang=js"
export * from "./ListingItemActiveSessions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports